import api from 'src/config/api';
import { getJsonResponse } from 'src/utils/ApiUtils';
import DeliveryOrder, { DeliveryOrderCriteria, PostDeliveryOrderBody } from 'src/interfaces/api/DeliveryOrder';
import { CollectionResponse } from 'src/interfaces/api/api';
import { Order } from 'src/interfaces/Table';
import useAuth from './useAuth';

const useDeliveryOrder = () => {
  const { fetch: authFetch } = useAuth();

  const create = async (
    deliveryOrder: PostDeliveryOrderBody & { token?: string },
    fromProvider = false
  ): Promise<DeliveryOrder> => {
    const { endpoint, ...options } = api.deliveryOrder.create(deliveryOrder, fromProvider);

    const currentFetch = fromProvider ? fetch : authFetch;

    const response = await currentFetch(endpoint, options);

    try {
      return await getJsonResponse<DeliveryOrder>(response);
    } catch (e) {
      throw new Error(e.message);
    }
  };

  const update = async (deliveryOrderId: string, deliveryOrder: PostDeliveryOrderBody): Promise<DeliveryOrder> => {
    const { endpoint, ...options } = api.deliveryOrder.update(deliveryOrderId, deliveryOrder);

    const response = await authFetch(endpoint, options);

    try {
      return await getJsonResponse<DeliveryOrder>(response);
    } catch (e) {
      throw new Error(e.message);
    }
  };

  const get = async (id: DeliveryOrder['id']): Promise<DeliveryOrder> => {
    const { endpoint, ...options } = api.deliveryOrder.get(id);

    const response = await authFetch(endpoint, options);

    try {
      return await getJsonResponse<DeliveryOrder>(response);
    } catch (e) {
      throw new Error(e.message);
    }
  };

  const getAll = async (
    searchCriteria: DeliveryOrderCriteria,
    page: number,
    limit: number,
    orderBy: keyof DeliveryOrder = 'createdAt',
    order: Order
  ): Promise<CollectionResponse<DeliveryOrder>> => {
    const { endpoint, ...options } = api.deliveryOrder.getAll(searchCriteria, orderBy, order, page, limit);

    const response = await authFetch(endpoint, options);

    try {
      return await getJsonResponse<CollectionResponse<DeliveryOrder>>(response);
    } catch (e) {
      throw new Error(e.message);
    }
  };

  return { getAll, get, create, update };
};

export default useDeliveryOrder;
